// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2fF6_","col":"CardReaderDesc_col__1h4o_","label":"CardReaderDesc_label__1-n-4"};